module.exports = __webpack_public_path__ + "img/coming-soon.4d672294.svg";